import getConfig from 'next/config';

export const getStickySaveShareBucketedCookie = (): string => {
  const {
    publicRuntimeConfig: { STICKY_SAVE_SHARE_EXPERIMENT_KEY },
  } = getConfig();
  return `convert_bucketed_${STICKY_SAVE_SHARE_EXPERIMENT_KEY}`;
};
